module.exports = __webpack_public_path__ + "img/photoHome.5321f177.jpg";